import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DbTranslationPipe } from './db-translation.pipe';



@NgModule({
  declarations: [DbTranslationPipe],
  imports: [
    CommonModule
  ],
  exports: [
    DbTranslationPipe
  ]
})
export class DbTranslationModule { }
